import type { ReactElement } from "react";

import { StyledSignalSelectionTooltipTrigger } from "app/pages/sales-intelligence/sub-modules/signals/components/shared/SignalSelectionTooltipTrigger/styles";
import type { SignalFilterDropdownLabelModel } from "app/pages/sales-intelligence/sub-modules/signals/models/view/SignalFilterDropdownLabelModel";
import { formatSelectionOverflowSuffix } from "app/pages/sales-intelligence/sub-modules/signals/utils/signalSelectionOverflow";

import { StyledFilterLabelText, StyledFilterOverflowCount } from "./styles";

type Props = {
    model: SignalFilterDropdownLabelModel;
};

const SignalFilterDropdownLabel = ({ model }: Props): ReactElement => {
    if (model.kind === "plain") {
        return <StyledFilterLabelText data-automation="signal-filter-plain-label">{model.label}</StyledFilterLabelText>;
    }

    if (model.kind === "singular") {
        return (
            <StyledFilterLabelText data-automation="signal-filter-singular-label">{model.label}</StyledFilterLabelText>
        );
    }

    const { primaryLabel, hiddenCount } = model;
    const overflowSuffix = formatSelectionOverflowSuffix(hiddenCount);

    return (
        <StyledSignalSelectionTooltipTrigger
            $flexGrow
            data-automation="signal-filter-partial-label"
        >
            <StyledFilterLabelText data-automation="signal-filter-partial-label-primary">
                {primaryLabel}
            </StyledFilterLabelText>
            {overflowSuffix ? (
                <StyledFilterOverflowCount data-automation="signal-filter-partial-label-overflow">
                    {overflowSuffix}
                </StyledFilterOverflowCount>
            ) : null}
        </StyledSignalSelectionTooltipTrigger>
    );
};

export default SignalFilterDropdownLabel;
